const featureTranslations: Partial<Record<string, [string, string]>> = {
  Товары: ['Products', '商品分析'],
  'Категории, магазины и бренды': ['Categories, stores and brands', '类目、店铺与品牌'],
  'Поисковые запросы': ['Search queries', '搜索关键词'],
  'Внутренняя аналитика': ['Business analytics', '店铺经营分析'],
  'Планирование поставок': ['Supply planning', '补货规划'],
  'Управление рекламой': ['Bid management', '广告管理'],
  'Управление ценами': ['Price management', '价格管理'],
  'Автоответы на отзывы': ['Automated review replies', '自动回复评论'],
  'Инструменты и автоматизация': ['Tools and automation', '工具与自动化'],
  'Cобираем данные по каждому товару': [
    'Track the performance of each product',
    '掌握每件商品的表现',
  ],
  'История цен, остатков на складе, выручки и продаж': [
    'Price, stock, revenue and sales history',
    '价格、库存、销售额与销量历史',
  ],
  'Позиции карточки в поиске по запросам': [
    'Product rankings for search queries',
    '商品在关键词搜索中的排名',
  ],
  'Как менялся контент карточки': ['Changes to product listing content', '商品详情内容变化'],
  'Выручка, продажи и средняя цена по категории': [
    'Category revenue, sales and average price',
    '类目销售额、销量与平均价格',
  ],
  'История и сезонность продаж по категории': [
    'Category sales history and seasonality',
    '类目销售历史与季节性',
  ],
  'Распределение выручки и товаров по ценовым диапазонам в категории': [
    'Revenue and product distribution by price range',
    '各价格区间的销售额与商品分布',
  ],
  'Помогаем сформировать стратегию продвижения': [
    'Build your search promotion strategy',
    '制定搜索推广策略',
  ],
  'История популярности и сезонности поискового запроса': [
    'Search query popularity and seasonal trends',
    '关键词热度历史与季节趋势',
  ],
  'Оценка представленности конкурентов по поисковому запросу': [
    'Competitor visibility for a search query',
    '竞争对手在关键词搜索中的曝光',
  ],
  'Поисковые запросы по категориям': ['Search queries by category', '按类目查看关键词'],
  'Подборки трендовых запросов': ['Discover trending search queries', '发现热门搜索关键词'],
  'Финансовая прозрачность ваших магазинов': [
    'Understand your stores’ finances',
    '清晰掌握店铺财务',
  ],
  'Реальная выручка, расходы и прибыль по магазину и по каждому товару': [
    'Revenue, expenses and profit by store and product',
    '按店铺与商品查看销售额、费用及利润',
  ],
  'ABC‑анализ прибыли и выручки': ['ABC analysis of profit and revenue', '利润与销售额的 ABC 分析'],
  'Поможем спланировать пополнение запасов товаров на складе': [
    'Plan your next stock replenishment',
    '规划下一次仓库补货',
  ],
  'Покажем, какие товары требуют поставки': [
    'Identify products that need replenishment',
    '找出需要补货的商品',
  ],
  'Расчёт количества товара и суммы планируемой поставки': [
    'Calculate replenishment quantities and value',
    '计算补货数量与金额',
  ],
  'Поможем контролировать расходы на продвижение товаров': [
    'Control your product advertising costs',
    '控制商品推广费用',
  ],
  'Покажем позицию, просмотры, клики и расходы рекламы в кластерах': [
    'Track rankings, impressions, clicks and costs by search cluster',
    '按搜索词组查看排名、展示、点击与广告费用',
  ],
  'Автоматическое пополнение бюджета и лимит расходов за день': [
    'Automatic budget top-ups and daily spending limits',
    '自动补充广告预算与每日支出限额',
  ],
  'Поможем контролировать цену на ваши товары': [
    'Keep your product prices under control',
    '掌控商品价格',
  ],
  'Отслеживаем цены на ваши товары каждую минуту и держим их под контролем': [
    'Monitor and manage your product prices automatically',
    '自动监控与管理商品价格',
  ],
  'Фиксированная цена — позволяет не участвовать в акциях': [
    'Keep a fixed price during marketplace promotions',
    '在平台促销期间保持固定价格',
  ],
  'Покажем подробную историю изменений цены с причинами': [
    'View price changes and their reasons',
    '查看价格变动记录及原因',
  ],
  'Изменим цену в зависимости от остатков, времени суток или цен конкурентов': [
    'Adjust prices by stock levels, schedule or competitor prices',
    '根据库存、时间或竞品价格调整定价',
  ],
  'Создавайте доверие к товару и управляйте репутацией бренда': [
    'Build trust and manage your brand’s reputation',
    '提升商品信任度并管理品牌声誉',
  ],
  'Поможем автоматически отвечать на отзывы пользователей': [
    'Reply to customer reviews automatically',
    '自动回复客户评论',
  ],
  'Если одно из стоп-слов есть в отзыве, то мы не будем на него отвечать': [
    'Skip reviews containing your stop words',
    '跳过包含指定屏蔽词的评论',
  ],
  'Инструменты для быстрого управления магазином': [
    'Tools for everyday store management',
    '高效管理店铺的工具',
  ],
  'SEO-оптимизация описания карточки товара': [
    'Product description SEO optimization',
    '商品描述 SEO 优化',
  ],
  'Калькулятор юнит‑экономики': ['Unit economics calculator', '单品利润计算器'],
  'Мониторинг внешней рекламы': ['External advertising monitoring', '站外广告监控'],
  'Структура и динамика расходов': ['Expense breakdown and trends', '费用构成与变化趋势'],
  'Динамика заказов, отмен и возвратов': [
    'Orders, cancellations and returns over time',
    '订单、取消与退货趋势',
  ],
  'Сводная аналитика магазинов и маркетплейсов': [
    'Consolidated store and marketplace analytics',
    '店铺与平台汇总分析',
  ],
  'Рассчитываем цену по заданной маржинальности': [
    'Calculate prices using your target margin',
    '根据目标利润率计算价格',
  ],
  'Управляем участием в акциях с заданным пределом снижения цены': [
    'Manage promotions with a price reduction limit',
    '设置降价上限，管理促销活动',
  ],
  'Проверяем позиции избранных кластеров каждые 5 минут и при необходимости меняем ставку': [
    'Check selected search cluster rankings every 5 minutes and adjust bids when needed',
    '每 5 分钟检查收藏词组的排名，并按需调整出价',
  ],
  'Выбирайте часы работы рекламы по тепловой карте': [
    'Choose advertising hours using the heatmap',
    '通过热力图选择广告投放时段',
  ],
  'Три стратегии управления ставками: оптимальная позиция, наивысшая позиция и фиксированная ставка':
    [
      'Three bidding strategies: optimal position, highest position and fixed bid',
      '三种出价策略：最佳排名、最高排名与固定出价',
    ],
  'ИИ определяет тему и настроение отзыва': [
    'AI identifies review topics and sentiment',
    'AI 识别评论主题与情感',
  ],
  'Правила ответа по оценке, теме отзыва, товару и бренду': [
    'Reply rules by rating, review topic, product and brand',
    '按评分、评论主题、商品与品牌设置回复规则',
  ],
  'ИИ отвечает по тексту отзыва или вашим шаблонам': [
    'AI replies using review content or your templates',
    'AI 根据评论内容或您的模板生成回复',
  ],
  'Проверка ИИ-ответов перед отправкой покупателю': [
    'Review AI replies before sending them to customers',
    '发送给买家前审核 AI 回复',
  ],
  'Распределение поставки по складам': ['Allocate supplies across warehouses', '按仓库分配补货'],
  'Подробный расчёт поставки по каждому товару': [
    'Detailed supply calculations for each product',
    '每件商品的详细补货计算',
  ],
  'Оценка упущенной выручки по товару': ['Estimated lost revenue by product', '商品预估损失销售额'],
  'Когда товар был в продаже, закончился или был удалён': [
    'See when a product was available, out of stock or removed',
    '查看商品在售、缺货或下架的时间',
  ],
  'Сравнение до четырёх товаров по показателям и позициям в поиске': [
    'Compare up to four products by metrics and search rankings',
    '比较最多四件商品的指标与搜索排名',
  ],
  'Анализ категорий, магазинов и брендов для оценки рынка и конкурентов': [
    'Analyze categories, stores and brands to assess markets and competitors',
    '分析类目、店铺与品牌，评估市场与竞争对手',
  ],
  'Распределение выручки между магазинами и брендами в категории': [
    'Revenue distribution across stores and brands in a category',
    '类目内店铺与品牌的销售额分布',
  ],
  'Ассортимент, продажи и выручка магазинов и брендов': [
    'Store and brand product ranges, sales and revenue',
    '店铺与品牌的商品、销量和销售额',
  ],
  'Просмотры, корзины, заказы и конверсия по запросу': [
    'Views, carts, orders and conversion by search query',
    '按关键词查看浏览、加购、订单与转化率',
  ],
  'Аналитика спроса по предметам и поисковым запросам': [
    'Demand analytics by subject and search query',
    '按商品品类与搜索关键词分析需求',
  ],
  'Генерация описания карточки товара': ['AI product description generation', 'AI 生成商品描述'],
  'Генерация и редактирование изображений для карточки товара': [
    'Generate and edit product images with AI',
    '使用 AI 生成和编辑商品图片',
  ],
  'Генерация видео для карточки товара по текстовому описанию или изображению': [
    'Generate product videos from text or images',
    '根据文字描述或图片生成商品视频',
  ],
  'ИИ-ассистент: вопросы о сервисе, идеи для товаров и помощь с расчётами': [
    'AI assistant for service questions, product ideas and calculations',
    'AI 助手：解答服务问题、提供商品创意与计算支持',
  ],
  'ИИ-аудит изображений, описания и отзывов товара с рекомендациями по улучшению': [
    'AI audit of product images, descriptions and reviews with improvement suggestions',
    'AI 分析商品图片、描述与评论，并提供改进建议',
  ],
  'Бот в Telegram и Макс с уведомлениями о продажах, выручке и заказах': [
    'Telegram and MAX bot with sales, revenue and order notifications',
    '通过 Telegram 和 MAX 机器人接收销量、销售额与订单通知',
  ],
  'Анализ ниш по выручке, конкуренции и оборачиваемости товаров': [
    'Analyze niches by revenue, competition and days of inventory',
    '按销售额、竞争程度与库存可售天数分析细分市场',
  ],
  'Мониторинг позиций товаров по выбранным поисковым запросам и история изменений': [
    'Track product rankings for selected search queries and their history',
    '监控商品在指定关键词下的排名与变化历史',
  ],
  'Сравнение позиций товаров в рекомендательных полках': [
    'Compare product rankings in recommendation shelves',
    '比较商品在推荐栏中的排名',
  ],
}

export default featureTranslations
